import { useId, useRef } from 'react';
import { ImagePlus, Trash2 } from 'lucide-react';
import { Button, IconButton } from './Button';
import styles from './ImageField.module.css';

/**
 * Bild auswählen mit Vorschau. onSelect erhält das File-Objekt (bzw. das Change-Event, wenn passEvent gesetzt ist).
 */
export function ImageField({
  label = 'Bild', preview, onSelect, onRemove, hint = 'Max. 10 MB · JPEG, PNG, WebP',
  accept = 'image/jpeg,image/jpg,image/png,image/webp', passEvent = false
}) {
  const id = useId();
  const inputRef = useRef(null);
  return (
    <div className={styles.field}>
      <span className={styles.label} id={`${id}-label`}>{label}</span>
      <div className={styles.box}>
        {preview ? (
          <span className={styles.preview}>
            <img src={preview} alt="Vorschau" />
            {onRemove && <IconButton icon={Trash2} label="Bild entfernen" size="sm" className={styles.remove} onClick={onRemove} />}
          </span>
        ) : (
          <span className={styles.empty}><ImagePlus aria-hidden /></span>
        )}
        <div className={styles.side}>
          <Button variant="secondary" size="sm" icon={ImagePlus} onClick={() => inputRef.current?.click()} aria-describedby={`${id}-label`}>
            {preview ? 'Bild ersetzen' : 'Bild wählen'}
          </Button>
          {hint && <span className={styles.hint}>{hint}</span>}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          hidden
          onChange={(e) => {
            if (passEvent) onSelect(e);
            else if (e.target.files?.[0]) onSelect(e.target.files[0]);
            e.target.value = '';
          }}
        />
      </div>
    </div>
  );
}
